import { ErreurApi } from '../../api/client.js';

const GENERIQUE = 'Une erreur est survenue de notre côté. Réessayez dans un instant ; si elle persiste, contactez le Cabinet MAAT.';

/** Phrase française à montrer pour une erreur d'appel (jamais le détail du serveur, qui peut nommer le mandant). */
export const phraseErreur = (e: unknown): string => (e instanceof ErreurApi ? e.messageUtilisateur : GENERIQUE);
